function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import deepmerge from 'deepmerge';
import debug from 'debug';
import EventEmitter from 'eventemitter3';
import { Router } from '../common/router/Router';
import * as errors from '../common/router/errors';
import { isSpecialUrl } from 'ilc-sdk/app';
import { triggerAppChange } from './navigationEvents';
import { appIdToNameAndSlot } from '../common/utils';
import { FRAGMENT_KIND } from '../common/constants';
import { slotWillBe } from './TransitionManager/TransitionManager';
import ilcEvents from './constants/ilcEvents';
var _currentUrl = /*#__PURE__*/new WeakMap();
var _singleSpa = /*#__PURE__*/new WeakMap();
var _location = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
var _registryConf = /*#__PURE__*/new WeakMap();
var _ilcConfigRoot = /*#__PURE__*/new WeakMap();
var _router = /*#__PURE__*/new WeakMap();
var _prevRoute = /*#__PURE__*/new WeakMap();
var _currentRoute = /*#__PURE__*/new WeakMap();
var _windowEventHandlers = /*#__PURE__*/new WeakMap();
var _forceSpecialRoute = /*#__PURE__*/new WeakMap();
var _i18n = /*#__PURE__*/new WeakMap();
var _debug = /*#__PURE__*/new WeakMap();
var _handlePageTransition = /*#__PURE__*/new WeakMap();
var _activeApps = /*#__PURE__*/new WeakMap();
var _ClientRouter_brand = /*#__PURE__*/new WeakSet();
var _setInitialRoutes = /*#__PURE__*/new WeakMap();
var _addEventListeners = /*#__PURE__*/new WeakMap();
var _onSingleSpaRoutingEvents = /*#__PURE__*/new WeakMap();
var _onClickLink = /*#__PURE__*/new WeakMap();
var _createSpecialRouteHandler = /*#__PURE__*/new WeakMap();
var _getCurrUrl = /*#__PURE__*/new WeakMap();
var ClientRouter = /*#__PURE__*/function (_EventEmitter) {
  function ClientRouter(ilcConfigRoot, _state) {
    var _this;
    var i18n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      unlocalizeUrl: function unlocalizeUrl(url) {
        return url;
      },
      localizeUrl: function localizeUrl(url) {
        return url;
      }
    };
    var singleSpa = arguments.length > 3 ? arguments[3] : undefined;
    var handlePageTransition = arguments.length > 4 ? arguments[4] : undefined;
    var location = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : window.location;
    var logger = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : window.console;
    _classCallCheck(this, ClientRouter);
    _this = _callSuper(this, ClientRouter);
    _classPrivateMethodInitSpec(_this, _ClientRouter_brand);
    _defineProperty(_this, "errors", errors);
    _classPrivateFieldInitSpec(_this, _currentUrl, void 0);
    _classPrivateFieldInitSpec(_this, _singleSpa, void 0);
    _classPrivateFieldInitSpec(_this, _location, void 0);
    _classPrivateFieldInitSpec(_this, _logger, void 0);
    _classPrivateFieldInitSpec(_this, _registryConf, void 0);
    _classPrivateFieldInitSpec(_this, _ilcConfigRoot, void 0);
    /** @type Object<Router> */
    _classPrivateFieldInitSpec(_this, _router, void 0);
    _classPrivateFieldInitSpec(_this, _prevRoute, void 0);
    _classPrivateFieldInitSpec(_this, _currentRoute, void 0);
    _classPrivateFieldInitSpec(_this, _windowEventHandlers, {});
    _classPrivateFieldInitSpec(_this, _forceSpecialRoute, null);
    _classPrivateFieldInitSpec(_this, _i18n, void 0);
    _classPrivateFieldInitSpec(_this, _debug, void 0);
    _defineProperty(_this, "render404", void 0);
    _classPrivateFieldInitSpec(_this, _handlePageTransition, void 0);
    _classPrivateFieldInitSpec(_this, _activeApps, {
      prev: {},
      current: {}
    });
    _defineProperty(_this, "getPrevRoute", function () {
      return _classPrivateFieldGet(_prevRoute, _this);
    });
    _defineProperty(_this, "getCurrentRoute", function () {
      return _classPrivateFieldGet(_currentRoute, _this);
    });
    _defineProperty(_this, "getPrevRouteProps", function (appName, slotName) {
      return _assertClassBrand(_ClientRouter_brand, _this, _getRouteProps).call(_this, appName, slotName, _classPrivateFieldGet(_prevRoute, _this));
    });
    _defineProperty(_this, "getCurrentRouteProps", function (appName, slotName) {
      return _assertClassBrand(_ClientRouter_brand, _this, _getRouteProps).call(_this, appName, slotName, _classPrivateFieldGet(_currentRoute, _this));
    });
    _defineProperty(_this, "match", function (url) {
      return _classPrivateFieldGet(_router, _this).match(_classPrivateFieldGet(_i18n, _this).unlocalizeUrl(url.replace(_classPrivateFieldGet(_location, _this).origin, '') || '/'));
    });
    _defineProperty(_this, "navigateToUrl", function (url) {
      return _classPrivateFieldGet(_singleSpa, _this).navigateToUrl(_classPrivateFieldGet(_i18n, _this).localizeUrl(url));
    });
    _classPrivateFieldInitSpec(_this, _setInitialRoutes, function (state) {
      // we should respect base tag for cached pages
      var base = document.querySelector('base');
      if (base) {
        var a = document.createElement('a');
        a.href = base.getAttribute('href');
        _classPrivateFieldSet(_currentRoute, _this, _classPrivateFieldGet(_router, _this).match(a.pathname + a.search));
        base.remove();
        _classPrivateFieldGet(_logger, _this).warn('ILC: <base> tag was used only for initial rendering and removed afterwards.\n' + 'Currently, ILC does not support it fully.\n' + 'Please open an issue if you need this functionality.');
      } else if (state.forceSpecialRoute === '404') {
        _classPrivateFieldSet(_currentRoute, _this, _classPrivateFieldGet(_router, _this).matchSpecial(_classPrivateFieldGet(_getCurrUrl, _this).call(_this), state.forceSpecialRoute));
      } else {
        _classPrivateFieldSet(_currentRoute, _this, _classPrivateFieldGet(_router, _this).match(_classPrivateFieldGet(_getCurrUrl, _this).call(_this)));
      }
      _classPrivateFieldSet(_prevRoute, _this, _classPrivateFieldGet(_currentRoute, _this));
      _classPrivateFieldGet(_activeApps, _this).prev = _assertClassBrand(_ClientRouter_brand, _this, _createActiveAppsObject).call(_this, _classPrivateFieldGet(_prevRoute, _this).slots);
      _classPrivateFieldGet(_activeApps, _this).current = _assertClassBrand(_ClientRouter_brand, _this, _createActiveAppsObject).call(_this, _classPrivateFieldGet(_currentRoute, _this).slots);
    });
    _classPrivateFieldInitSpec(_this, _addEventListeners, function () {
      _classPrivateFieldGet(_windowEventHandlers, _this)[ilcEvents.BEFORE_ROUTING] = _classPrivateFieldGet(_onSingleSpaRoutingEvents, _this);
      _classPrivateFieldGet(_windowEventHandlers, _this)[ilcEvents.NOT_FOUND] = _this.render404;
      for (var key in _classPrivateFieldGet(_windowEventHandlers, _this)) {
        if (!_classPrivateFieldGet(_windowEventHandlers, _this).hasOwnProperty(key)) {
          continue;
        }
        window.addEventListener(key, _classPrivateFieldGet(_windowEventHandlers, _this)[key]);
      }

      // It's important to attach "click" listener to window as React apps attach their own to "document"
      // So if ours is also at the document - it will be likely executed first. Which breaks "defaultPrevented" detection
      // From React doc:
      //    React doesn’t actually attach event handlers to the nodes themselves.
      //    When React starts up, it starts listening for all events at the top level using a single event listener.
      window.addEventListener('click', _classPrivateFieldGet(_onClickLink, _this));
    });
    _classPrivateFieldInitSpec(_this, _onSingleSpaRoutingEvents, function () {
      _classPrivateFieldSet(_prevRoute, _this, _classPrivateFieldGet(_currentRoute, _this));
      var newUrl = _classPrivateFieldGet(_getCurrUrl, _this).call(_this);
      if (_classPrivateFieldGet(_forceSpecialRoute, _this) !== null && _classPrivateFieldGet(_forceSpecialRoute, _this).url === _classPrivateFieldGet(_getCurrUrl, _this).call(_this, true)) {
        _classPrivateFieldSet(_currentRoute, _this, _classPrivateFieldGet(_router, _this).matchSpecial(newUrl, _classPrivateFieldGet(_forceSpecialRoute, _this).id));
      } else if (_classPrivateFieldGet(_forceSpecialRoute, _this) !== null) {
        // Reset variable if it was set & now we go to different route
        _classPrivateFieldSet(_forceSpecialRoute, _this, null);
      }

      // fix for google cached pages.
      // if open any cached page and scroll to "#features" section:
      // only hash will be changed so router.match will return error, since <base> tag has already been removed.
      // so in this cases we shouldn't regenerate currentRoute
      if (_classPrivateFieldGet(_currentUrl, _this) !== newUrl) {
        _classPrivateFieldSet(_currentRoute, _this, _classPrivateFieldGet(_router, _this).match(_classPrivateFieldGet(_getCurrUrl, _this).call(_this)));
        _classPrivateFieldSet(_currentUrl, _this, newUrl);
      }

      // In case if base template was changes we expect not SPA navigation
      var isBaseTemplateChanged = _classPrivateFieldGet(_currentRoute, _this) && _classPrivateFieldGet(_prevRoute, _this).template !== _classPrivateFieldGet(_currentRoute, _this).template;
      if (isBaseTemplateChanged) {
        _classPrivateFieldGet(_location, _this).href = _classPrivateFieldGet(_currentUrl, _this);
        return;
      }
      _classPrivateFieldGet(_activeApps, _this).prev = _assertClassBrand(_ClientRouter_brand, _this, _createActiveAppsObject).call(_this, _classPrivateFieldGet(_prevRoute, _this).slots);
      _classPrivateFieldGet(_activeApps, _this).current = _assertClassBrand(_ClientRouter_brand, _this, _createActiveAppsObject).call(_this, _classPrivateFieldGet(_currentRoute, _this).slots);
      var appsWithDifferentProps = _assertClassBrand(_ClientRouter_brand, _this, _getAppsWithDifferentProps).call(_this, _classPrivateFieldGet(_prevRoute, _this).slots, _classPrivateFieldGet(_currentRoute, _this).slots);
      if (appsWithDifferentProps.length) {
        var appsToForceRerender = [];
        var updateEventsToTrigger = [];
        appsWithDifferentProps.forEach(function (_ref) {
          var slotName = _ref.slotName,
            appName = _ref.appName;
          var eventUpdateFragment = ilcEvents.updateAppInSlot(slotName, appName);

          // if fragment provided "update" lifecycle method then it will be updated immediately w/o remounting app
          // otherwise the fragment will be unmounted and mounted with new props
          if (_this.listenerCount(eventUpdateFragment)) {
            updateEventsToTrigger.push(eventUpdateFragment);
          } else {
            // temporary remove slot with old props, to remove it from DOM
            // it will be rendered with new props with the help of "triggerAppChange"
            appsToForceRerender.push(appName);
            delete _classPrivateFieldGet(_activeApps, _this).current[slotName];
          }
        });
        window.addEventListener(ilcEvents.PAGE_READY, function () {
          if (appsToForceRerender.length) {
            _classPrivateFieldGet(_logger, _this).info("ILC: Triggering app re-mount for [".concat(appsToForceRerender, "] due to changed props."));
            triggerAppChange();
          }
          if (updateEventsToTrigger.length) {
            updateEventsToTrigger.forEach(_this.emit.bind(_this));
          }
        }, {
          once: true
        });
      }
    });
    _classPrivateFieldInitSpec(_this, _onClickLink, function (event) {
      var metaKey = event.metaKey,
        altKey = event.altKey,
        ctrlKey = event.ctrlKey,
        shiftKey = event.shiftKey;
      if (metaKey || altKey || ctrlKey || shiftKey) {
        return;
      }
      var anchor = event.target.tagName === 'A' ? event.target : event.target.closest('a');
      var href = anchor && anchor.getAttribute('href');
      if (event.defaultPrevented || href === null || !['', '_self'].includes(anchor.target) || isSpecialUrl(href)) {
        return;
      }
      var _this$match = _this.match(href),
        specialRole = _this$match.specialRole;
      if (specialRole === null) {
        _classPrivateFieldGet(_debug, _this).call(_this, "Calling singleSpa.navigateToUrl(\"".concat(href, "\")"));
        _classPrivateFieldGet(_singleSpa, _this).navigateToUrl(href);
        event.preventDefault();
      }
    });
    _classPrivateFieldInitSpec(_this, _createSpecialRouteHandler, function (specialRouteId) {
      return function (e) {
        var appId = e.detail && e.detail.appId;
        var mountedApps = _classPrivateFieldGet(_singleSpa, _this).getMountedApps();
        if (!mountedApps.includes(appId)) {
          return _classPrivateFieldGet(_logger, _this).warn("ILC: Ignoring special route \"".concat(specialRouteId, "\" trigger which came from not mounted app \"").concat(appId, "\". ") + "Currently mounted apps: ".concat(mountedApps.join(', '), "."));
        }
        var _appIdToNameAndSlot = appIdToNameAndSlot(appId),
          appName = _appIdToNameAndSlot.appName,
          slotName = _appIdToNameAndSlot.slotName;
        var fragmentKind = _this.getRelevantAppKind(appName, slotName);
        var isPrimary = fragmentKind === FRAGMENT_KIND.primary;
        if (specialRouteId === 404 && !isPrimary) {
          return _classPrivateFieldGet(_logger, _this).warn("ILC: Ignoring special route \"".concat(specialRouteId, "\" trigger which came from non-primary app \"").concat(appId, "\". ") + "\"".concat(appId, "\" is \"").concat(fragmentKind, "\""));
        }
        _classPrivateFieldGet(_logger, _this).info("ILC: Special route \"".concat(specialRouteId, "\" was triggered by \"").concat(appId, "\" app. Performing rerouting..."));
        _classPrivateFieldSet(_forceSpecialRoute, _this, {
          id: specialRouteId,
          url: _classPrivateFieldGet(_getCurrUrl, _this).call(_this, true)
        });
        triggerAppChange(); //This call would immediately invoke "ilc:before-routing" and start apps mount/unmount process
      };
    });
    _classPrivateFieldInitSpec(_this, _getCurrUrl, function () {
      var withLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var url = _classPrivateFieldGet(_location, _this).pathname + _classPrivateFieldGet(_location, _this).search;
      if (withLocale) {
        return url;
      }
      return _classPrivateFieldGet(_i18n, _this).unlocalizeUrl(url);
    });
    _classPrivateFieldSet(_handlePageTransition, _this, handlePageTransition);
    _classPrivateFieldSet(_singleSpa, _this, singleSpa);
    _classPrivateFieldSet(_location, _this, location);
    _classPrivateFieldSet(_logger, _this, logger);
    _classPrivateFieldSet(_i18n, _this, i18n);
    _classPrivateFieldSet(_ilcConfigRoot, _this, ilcConfigRoot);
    _classPrivateFieldSet(_registryConf, _this, _classPrivateFieldGet(_ilcConfigRoot, _this).getConfig());
    _classPrivateFieldSet(_router, _this, new Router(_classPrivateFieldGet(_registryConf, _this)));
    _classPrivateFieldSet(_currentUrl, _this, _classPrivateFieldGet(_getCurrUrl, _this).call(_this));
    _classPrivateFieldSet(_debug, _this, debug('ILC:ClientRouter'));
    _this.render404 = _classPrivateFieldGet(_createSpecialRouteHandler, _this).call(_this, 404);
    _classPrivateFieldGet(_setInitialRoutes, _this).call(_this, _state);
    _classPrivateFieldGet(_addEventListeners, _this).call(_this);
    return _this;
  }
  _inherits(ClientRouter, _EventEmitter);
  return _createClass(ClientRouter, [{
    key: "getRelevantAppKind",
    value:
    /**
     * Get the relevant application kind for a given app name and slot name.
     *
     * @param {string} appName - The name of the application.
     * @param {string} slotName - The name of the slot.
     *
     * @returns {string} 'regular' | 'primary' | 'essential'
     *
     * @throws {RouterError} Throws a RouterError if information about the app cannot be found in the registry.
     *
     * @method
     */
    function getRelevantAppKind(appName, slotName) {
      var app = _classPrivateFieldGet(_registryConf, this).apps[appName];
      if (!app) {
        throw new this.errors.RouterError({
          message: 'Can not find info about the app.',
          data: {
            appName: appName
          }
        });
      }
      var appKind = app.kind;
      var currentRoute = this.getCurrentRoute();
      var slotKindCurr = currentRoute.slots[slotName] && currentRoute.slots[slotName].kind;
      // Here we're also checking previous route as app may throw an error right after URL change.
      // During unmounting for example.
      var previousRoute = this.getPrevRoute();
      var slotKindPrev = previousRoute.slots[slotName] && previousRoute.slots[slotName].kind;
      return slotKindCurr || slotKindPrev || appKind;
    }
  }, {
    key: "isAppWithinSlotActive",
    value: function isAppWithinSlotActive(appName, slotName) {
      var isActive = _classPrivateFieldGet(_activeApps, this).current[slotName] === appName;
      var wasActive = _classPrivateFieldGet(_activeApps, this).prev[slotName] === appName;
      var isClientless = _classPrivateFieldGet(_ilcConfigRoot, this).isApplicationClientlessByAppName(appName);

      //Todo: side effect have to be removed from getter
      var willBe = slotWillBe["default"];
      if (!wasActive && isActive) {
        willBe = slotWillBe.rendered;
      }
      if (wasActive && !isActive) {
        willBe = slotWillBe.removed;
      }
      if (isClientless) {
        willBe = slotWillBe["default"];
      }
      _classPrivateFieldGet(_handlePageTransition, this).call(this, slotName, willBe, this.getRelevantAppKind(appName, slotName));
      return isActive;
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      for (var key in _classPrivateFieldGet(_windowEventHandlers, this)) {
        if (!_classPrivateFieldGet(_windowEventHandlers, this).hasOwnProperty(key)) {
          continue;
        }
        window.removeEventListener(key, _classPrivateFieldGet(_windowEventHandlers, this)[key]);
      }
      _classPrivateFieldSet(_windowEventHandlers, this, {});
      window.removeEventListener('click', _classPrivateFieldGet(_onClickLink, this));
    }
  }]);
}(EventEmitter);
function _getRouteProps(appName, slotName, route) {
  var appConfig = _classPrivateFieldGet(_ilcConfigRoot, this).getConfigForAppByName(appName);
  var routeConfig = route.slots[slotName];
  if (appConfig === undefined) {
    throw new this.errors.RouterError({
      message: 'Can not find info about the app.',
      data: {
        appName: appName
      }
    });
  }
  if (routeConfig === undefined) {
    throw new this.errors.RouterError({
      message: 'Can not find info about the slot.',
      data: {
        slotName: slotName
      }
    });
  }
  var appProps = appConfig.props || {};
  var routeProps = routeConfig.props || {};
  var finalRouteProps = deepmerge(appProps, routeProps);
  return finalRouteProps;
}
function _createActiveAppsObject(slots) {
  return Object.entries(slots).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      slotName = _ref3[0],
      slotApp = _ref3[1];
    acc[slotName] = slotApp.appName;
    return acc;
  }, {});
}
function _getAppsWithDifferentProps(prevSlots, currentSlots) {
  return Object.entries(prevSlots).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      slotName = _ref5[0],
      prevSlotApp = _ref5[1];
    var currentSlotApp = currentSlots[slotName];
    if (!currentSlotApp) {
      return acc;
    }
    var isTheSameSlotApp = currentSlotApp.appName === prevSlotApp.appName;
    if (!isTheSameSlotApp) {
      return acc;
    }
    if (JSON.stringify(prevSlotApp.props) === JSON.stringify(currentSlotApp.props)) {
      return acc;
    }
    return [].concat(_toConsumableArray(acc), [{
      appName: currentSlotApp.appName,
      slotName: slotName
    }]);
  }, []);
}
export { ClientRouter as default };